const helper = {
	// 根据name获取地址栏的参数值
	getQueryString (name) {
		let reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
		let hash = window.location.hash
		let search = hash.split('?')
		let r = search[1] && search[1].match(reg)
		if (r != null) return r[2]; return ''
	},

	// 拼接参数至url
	queryString (url, query) {
		let str = []
		for (let key in query) {
			str.push(key + '=' + query[key])
		}
		let paramStr = str.join('&')
		return paramStr ? `${url}?${paramStr}` : url
	},

	// 自定义判断元素类型JS
	toType (obj) {
		return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
	},

	// 参数过滤函数
	filterNull (o) {
	  if(o.ignoreFilterNull){
	    return o;
    }
		for (var key in o) {
			if (o[key] === null || o[key] === undefined || o[key] === '') {
				delete o[key]
			}
			if (this.toType(o[key]) === 'string') {
//				o[key] = o[key].trim()
			} else if (this.toType(o[key]) === 'object') {
				o[key] = this.filterNull(o[key])
			} else if (this.toType(o[key]) === 'array') {
				o[key] = this.filterNull(o[key])
			} else if (this.toType(o[key]) === 'number') {
				o[key] = this.filterNull(o[key])
			}
		}
		return o
	}
}
export default helper



// WEBPACK FOOTER //
// ./src/axios/helper.js